module.exports = __webpack_public_path__ + "static/media/leia-organa.aec02419.png";